/* @ngInject */
const askDispatch = (
  dispatchLocal,
  dispatchFormat,
  dispatchRequest,
  dispatchData,
  utils,
  dispatchLabels,
  toaster,
  valueHandler
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(dispatchLabels.ask.delete)) {
      try {
        const message = await dispatchRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(dispatchData.myDispatches, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_dispatch, _back = false) => {
    try {
      let dispatch = utils.copy(_dispatch)
      dispatch.id = dispatchLocal.getCurrentId()
      dispatch = dispatchFormat.server(dispatch)

      const response = await dispatchRequest.update(dispatch)
      toaster.message(response.message)
      utils.updateFromArray(dispatchData.myDispatches, response.dispatch)
      if (_back) { utils.$back() }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default askDispatch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/ask.service.js